import "./DisclaimerAccordionModal.scss";
import DisclaimerInfoIcon from "../../../../assets/icons/info-icon.png";
import { useConfig } from "../../../../contexts/useConfig";
import { useEffect, useRef, useState } from "react";
import { getPropertyOrDefault } from "../../../../helpers/helpers";
import { motion } from "framer-motion"
// import { useLocalSessionSettings } from "../../../../contexts/useLocalSessionSettings";




export default function DisclaimerAccordionModal(props) {
   const [config] = useConfig();

   // const disclaimerIsVisible = config.disclaimerInformation?.disclaimerMode === "alwaysVisible";
   const disclaimerContent = getPropertyOrDefault(config.disclaimerInformation?.disclaimerInfoText, "");
   const openDelay = getPropertyOrDefault(config.disclaimerInformation?.disclaimerOpenDelay, 2);
   const [disclaimerTextContent, setDisclaimerTextContent] = useState(typeof (disclaimerContent) === "string" ? (disclaimerContent).split('\n') : disclaimerContent);
   const [isOpen, setIsOpen] = useState(true);
   const [isDelayingOpen, setIsDelayingOpen] = useState(true);
   const disclaimerRef = useRef();
   const disclaimerUiRef = useRef();
   // const [localSessionSettings, updateLocalSessionSettings] = useLocalSessionSettings();
   // const [isMobile,] = useState(localSessionSettings.isMobile);


   // const contentVariants = {
   //    open: {maxHeight: "100%"},
   //    closed: { maxHeight: "69px" },
   // }

   const toggleOpenDisclaimer = () => {
      setIsOpen(prev => !prev);
   }

   useEffect(() => {
      if ("isVisible" in props && !props.isVisible) {
         return null;
      }
      if (typeof (disclaimerContent) === "string") {
         setDisclaimerTextContent((disclaimerContent).split('\n'))
      }
   }, [disclaimerContent, props])

   useEffect(() => {
      setTimeout(() => setIsDelayingOpen(false), openDelay * 1000); 
   }, [setIsDelayingOpen, openDelay])

   let yClosed = 0;
   let boxHeight = 0;
   // Retrieve the current value of a CSS variable
   if (disclaimerRef.current) {
      var yClosedString = getComputedStyle(disclaimerRef.current).getPropertyValue('--y-closed');
      yClosed = parseFloat(yClosedString.substring(0, yClosedString.length - 1));
      console.log("yClosed", yClosed)
   }

   if (disclaimerUiRef.current) {
      boxHeight = disclaimerUiRef.current.clientHeight;

   }

   const mobileMode = yClosed < 0;
   const animationVariants = {
      open: {y: mobileMode? 0 : 0, opacity: 1},
      closed: { y:  mobileMode ? -(boxHeight-48) : (boxHeight - 48), opacity: 0.8},

   };

   return (<>
      {config.disclaimerInformation && <motion.div 
      variants={animationVariants}
      initial="open"
      animate={isDelayingOpen ? "closed" : (isOpen ? "open" : "closed")}
      className="disclaimer"
      ref={disclaimerRef}
      style={{originY: 0,}}
      onClick={toggleOpenDisclaimer}
      >
         <div className={"disc-acc-main-cont " + props.deviceType}>
         <div className="disclaimer-acc-modal" ref={disclaimerUiRef}>
            <div className={"tab"}>
               <div className="tab-inner"></div>
            </div>
            <div className="da-grid">
            <div className="da-icon-cont">
               <img src={DisclaimerInfoIcon} className="disc-acc-icon" alt="Disclaimer-Icon" />
            </div>
            <div className={`da-inner-container`}>
               {(config.disclaimerInformation?.disclaimerInfoHeading &&
                  <h2 className="da-modal__heading">{(config.disclaimerInformation?.disclaimerInfoHeading)}</h2>
               )}
               <p className="da-inner-container__text">{disclaimerTextContent.map((line, index) => <span key={index}>{line}<br /></span>)}</p>
            </div>
            </div>
               <div className={"tab tab-mobile"}>
                  <div className="tab-inner"></div>
               </div>
            {/* <div className="expand-button">
               <button onClick={toggleExpandDisclaimer}>{expanded ? "show less" : "read more"}</button>
            </div> */}
         </div>
      </div>
      </motion.div>}
      </>
   );
}
